// extracted by mini-css-extract-plugin
export var blockedMessage = "_99-3";
export var blockedOverlay = "_99-1";
export var fadeIn = "_99-2";
export var hereLink = "_99-0";
export var slideUp = "_99-4";